import axios from "axios";
import DevSwitch from '../../../DevSwitch'

export function requestGetJPAilmentFieldCompare() {
  if (DevSwitch == true) {
    return axios.get('data/_dir/field/JPCompare.json', { 'muteHttpExceptions': true })
  } else {
    return axios.get('https://www.dissidiacompendium.com/data/_dir/field/JPCompare.json', { 'muteHttpExceptions': true })
  }
}
